/*
 * The texts of the context extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	pages: {
		admin: {
			settings: {
				context_roles_and_permissions: {
					context_roles: 'Context roles',
					context_permissions: 'Context permissions',
				},
			},
		},
		context: {
			users: {
				title: 'People',
			},
		},
	},
	components: {
		user_memberships: {
			title: 'Memberships',
		},
	},
	modals: {
		add_user: {
			title: 'Add person',
			input: 'Select person',
		},
		invite_user: {
			title: 'Invite or add person',
			input: 'Search by name or e-mail address',
			context_role: 'Role',
		},
	},
	data: {
		context_role: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			context_model_type: 'Context model',
			description: 'Description',
			context_permissions: 'Permissions',
		},
		context_permission: {
			id: 'Id',
			name: 'Name',
			guard_name: 'Guard',
			context_model_type: 'Context model',
			description: 'Description',
		},
	},
	confirms: {
		remove_context_user: {
			title: 'Remove person',
			text: 'Remove {name} from \'{context}\'?',
		},
	},
	tabs: {
		context_settings: {
			members: 'Members',
		},
		admin_settings: {
			context_roles_and_permissions: 'Context roles & permissions',
		},
	},
};
